/**
 * Custom Mega Menu - Modal Style Navigation
 */

class CustomMegaMenu {
  constructor() {
    this.menu = document.querySelector('[data-custom-mega-menu]');
    this.overlay = document.querySelector('[data-custom-mega-menu-overlay]');
    this.closeBtn = document.querySelector('[data-custom-mega-menu-close]');
    this.backBtn = document.querySelector('[data-menu-back]');
    this.breadcrumb = document.querySelector('[data-menu-breadcrumb]');
    this.breadcrumbText = document.querySelector('[data-breadcrumb-text]');
    this.menuHeading = document.querySelector('[data-menu-heading]');
    
    this.currentLevel = 'main';
    this.levelHistory = [];
    
    this.init();
  }

  init() {
    // Store original title
    if (this.menuHeading) {
      const originalTitle = this.menuHeading.textContent;
      this.menuHeading.setAttribute('data-original-title', originalTitle);
    }

    // Find all navigation triggers
    const triggers = document.querySelectorAll('[data-menu-trigger]');
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        const levelId = trigger.getAttribute('data-menu-trigger');
        const title = trigger.getAttribute('data-menu-title');
        this.navigateToLevel(levelId, title);
      });
    });

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.close());
    }

    // Overlay click
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    // Back button
    if (this.backBtn) {
      this.backBtn.addEventListener('click', () => this.goBack());
    }

    // ESC key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  open() {
    if (this.menu && this.overlay) {
      this.overlay.classList.add('custom-mega-menu-overlay--active');
      this.menu.classList.add('custom-mega-menu--active');
      document.body.style.overflow = 'hidden';
    }
  }

  close() {
    if (this.menu && this.overlay) {
      this.overlay.classList.remove('custom-mega-menu-overlay--active');
      this.menu.classList.remove('custom-mega-menu--active');
      document.body.style.overflow = '';
      
      // Reset to main level after animation
      setTimeout(() => {
        this.resetToMain();
      }, 300);
    }
  }

  isOpen() {
    return this.menu && this.menu.classList.contains('custom-mega-menu--active');
  }

  navigateToLevel(levelId, title) {
    console.log('Navigating to level:', levelId, 'Title:', title);
    
    const currentLevelEl = document.querySelector(`[data-menu-level="${this.currentLevel}"]`);
    const nextLevelEl = document.querySelector(`[data-menu-level="${levelId}"]`);

    console.log('Current level element:', currentLevelEl);
    console.log('Next level element:', nextLevelEl);

    if (!nextLevelEl) {
      console.warn('Next level not found for:', levelId);
      return;
    }

    // Save current level to history
    this.levelHistory.push({
      id: this.currentLevel,
      title: this.menuHeading ? this.menuHeading.textContent : ''
    });

    // Hide current level
    if (currentLevelEl) {
      currentLevelEl.classList.remove('custom-mega-menu__level--active');
    }

    // Show next level
    nextLevelEl.classList.add('custom-mega-menu__level--active');
    this.currentLevel = levelId;

    // Update breadcrumb
    this.updateBreadcrumb(title);

    // Update heading
    if (this.menuHeading) {
      this.menuHeading.textContent = title;
    }
    
    console.log('Navigation complete. Current level:', this.currentLevel);
  }

  goBack() {
    if (this.levelHistory.length === 0) return;

    const previousLevel = this.levelHistory.pop();
    const currentLevelEl = document.querySelector(`[data-menu-level="${this.currentLevel}"]`);
    const previousLevelEl = document.querySelector(`[data-menu-level="${previousLevel.id}"]`);

    if (!previousLevelEl) return;

    // Hide current level
    if (currentLevelEl) {
      currentLevelEl.classList.remove('custom-mega-menu__level--active');
    }

    // Show previous level
    previousLevelEl.classList.add('custom-mega-menu__level--active');
    this.currentLevel = previousLevel.id;

    // Update breadcrumb
    if (this.levelHistory.length === 0) {
      this.hideBreadcrumb();
    } else {
      const parentLevel = this.levelHistory[this.levelHistory.length - 1];
      this.updateBreadcrumb(parentLevel.title);
    }

    // Update heading
    if (this.menuHeading) {
      this.menuHeading.textContent = previousLevel.title;
    }
  }

  updateBreadcrumb(title) {
    if (this.breadcrumb && this.breadcrumbText) {
      const breadcrumbPath = this.levelHistory.map(level => level.title).join(' / ');
      const fullPath = breadcrumbPath ? `${breadcrumbPath} / ${title}` : title;
      
      this.breadcrumbText.textContent = fullPath;
      this.breadcrumb.style.display = 'flex';
    }
  }

  hideBreadcrumb() {
    if (this.breadcrumb) {
      this.breadcrumb.style.display = 'none';
    }
  }

  resetToMain() {
    // Hide all levels
    const allLevels = document.querySelectorAll('[data-menu-level]');
    allLevels.forEach(level => {
      level.classList.remove('custom-mega-menu__level--active');
    });

    // Show main level
    const mainLevel = document.querySelector('[data-menu-level="main"]');
    if (mainLevel) {
      mainLevel.classList.add('custom-mega-menu__level--active');
    }

    // Reset state
    this.currentLevel = 'main';
    this.levelHistory = [];
    this.hideBreadcrumb();

    // Reset heading to original title
    if (this.menuHeading) {
      const originalTitle = this.menuHeading.getAttribute('data-original-title') || this.menuHeading.textContent;
      this.menuHeading.textContent = originalTitle;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.customMegaMenu = new CustomMegaMenu();
  });
} else {
  window.customMegaMenu = new CustomMegaMenu();
}

// Function to open menu from external triggers
window.openCustomMegaMenu = function() {
  if (window.customMegaMenu) {
    window.customMegaMenu.open();
  }
};

